export default {
  title: 'Projekt Riportok',
  subtitle: 'Projektek és feladatok részletes elemzése',
  
  // Tabs
  tabs: {
    overview: 'Áttekintés',
    timeTracking: 'Időmérés',
    tasks: 'Feladatok',
    team: 'Csapat',
    export: 'Export'
  },
  
  // Filters
  filters: {
    title: 'Szűrők',
    dateRange: 'Időszak',
    project: 'Projekt',
    allProjects: 'Összes projekt',
    user: 'Felhasználó',
    allUsers: 'Összes felhasználó',
    status: 'Státusz',
    priority: 'Prioritás',
    apply: 'Alkalmaz',
    reset: 'Visszaállít',
    custom: 'Egyéni',
    today: 'Ma',
    yesterday: 'Tegnap',
    thisWeek: 'Ez a hét',
    lastWeek: 'Múlt hét',
    thisMonth: 'Ez a hónap',
    lastMonth: 'Múlt hónap',
    thisYear: 'Ez az év',
    from: 'Kezdő dátum',
    to: 'Záró dátum'
  },
  
  // Overview
  overview: {
    title: 'Áttekintés',
    totalProjects: 'Összes projekt',
    activeProjects: 'Aktív projektek',
    completedProjects: 'Befejezett projektek',
    totalTasks: 'Összes feladat',
    completedTasks: 'Befejezett feladatok',
    totalTime: 'Összes idő',
    billableTime: 'Számlázható idő',
    completionRate: 'Teljesítési arány',
    averageTaskTime: 'Átlagos feladat idő',
    overdueTasks: 'Lejárt feladatok'
  },
  
  // Time Tracking
  timeTracking: {
    title: 'Időmérés Riport',
    byProject: 'Projekt szerint',
    byUser: 'Felhasználó szerint',
    byTask: 'Feladat szerint',
    totalTracked: 'Összes mért idő',
    billable: 'Számlázható',
    nonBillable: 'Nem számlázható',
    breakdown: 'Bontás',
    hours: 'óra',
    noData: 'Nincs adat a kiválasztott időszakra',
    topProjects: 'Legtöbb időt igénylő projektek',
    topUsers: 'Legtöbb időt dolgozó felhasználók',
    dailyBreakdown: 'Napi bontás',
    weeklyBreakdown: 'Heti bontás',
    monthlyBreakdown: 'Havi bontás'
  },
  
  // Tasks
  tasks: {
    title: 'Feladat Elemzés',
    byStatus: 'Státusz szerint',
    byPriority: 'Prioritás szerint',
    byProject: 'Projekt szerint',
    completionTrend: 'Teljesítési trend',
    averageCompletionTime: 'Átlagos teljesítési idő',
    onTimeCompletion: 'Időben teljesített',
    overdueCompletion: 'Késve teljesített',
    taskDistribution: 'Feladat eloszlás',
    statusBreakdown: 'Státusz bontás',
    priorityBreakdown: 'Prioritás bontás'
  },
  
  // Team
  team: {
    title: 'Csapat Teljesítmény',
    performance: 'Teljesítmény',
    tasksCompleted: 'Befejezett feladatok',
    hoursWorked: 'Ledolgozott órák',
    efficiency: 'Hatékonyság',
    topPerformers: 'Legjobb teljesítők',
    workload: 'Munkaterhelés',
    activeTasks: 'Aktív feladatok',
    completionRate: 'Teljesítési arány',
    averageTasksPerDay: 'Átlagos feladatok naponta'
  },
  
  // Export
  export: {
    title: 'Riport Export',
    format: 'Formátum',
    pdf: 'PDF Dokumentum',
    excel: 'Excel Táblázat',
    csv: 'CSV Fájl',
    includeCharts: 'Grafikonok mellékelése',
    includeDetails: 'Részletek mellékelése',
    download: 'Letöltés',
    email: 'Email küldés',
    emailTo: 'Címzett',
    emailSubject: 'Tárgy',
    emailMessage: 'Üzenet',
    send: 'Küldés',
    downloading: 'Letöltés...',
    sending: 'Küldés...',
    success: 'Sikeres export',
    error: 'Hiba történt az export során',
    button: 'Elvégzett munkák exportálása',
    noData: 'Nincs exportálható adat'
  },
  
  // Charts
  charts: {
    loading: 'Adatok betöltése...',
    noData: 'Nincs megjeleníthető adat',
    total: 'Összesen',
    average: 'Átlag',
    percentage: 'Százalék'
  },
  
  // Messages
  messages: {
    loading: 'Riport generálása...',
    error: 'Hiba történt a riport betöltése során',
    noProjects: 'Nincs projekt a kiválasztott időszakban',
    noTasks: 'Nincs feladat a kiválasztott időszakban',
    noTimeEntries: 'Nincs időbejegyzés a kiválasztott időszakban'
  }
};
